import React, { useState } from 'react';
import QAChatModal from './QAChatModal';

/**
 * Floating Action Button for Q&A
 * Displays at the bottom right and opens the Q&A chat modal
 */
const QAFloatingButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      {/* Floating Action Button */}
      <div className="fixed bottom-6 right-6 z-40">
        <button
          onClick={() => setIsModalOpen(true)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="group relative bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-700 text-white rounded-full p-4 shadow-2xl hover:shadow-3xl hover:from-blue-500 hover:via-blue-600 hover:to-indigo-600 transform hover:scale-110 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-blue-300"
          aria-label="Search Transcriptions"
        >
          {/* Icon - Search with Knowledge Base */}
          <svg 
            className="w-7 h-7" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            strokeWidth={2}
          >
            {/* Database/Knowledge Base */}
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
              opacity="0.6"
            />
            {/* Search Icon Overlay */}
            <circle 
              cx="16" 
              cy="16" 
              r="3.5" 
              strokeWidth={2.5}
            />
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2.5}
              d="M21 21l-2.5-2.5" 
            />
          </svg>
          
          {/* Ripple effect */}
          <span className="absolute inset-0 rounded-full bg-blue-400 opacity-0 group-hover:opacity-25 animate-ping"></span>
          
          {/* Pulse animation when not hovered */}
          {!isHovered && (
            <span className="absolute inset-0 rounded-full bg-blue-400 opacity-75 animate-pulse"></span>
          )}
          
          {/* Tooltip */}
          <div 
            className={`absolute right-full mr-3 top-1/2 transform -translate-y-1/2 whitespace-nowrap bg-gray-900 text-white text-sm px-4 py-2 rounded-lg shadow-lg transition-all duration-200 ${
              isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
            }`}
          >
            <div className="font-semibold">Search Transcriptions</div>
            <div className="text-xs text-gray-300 mt-0.5">Ask questions about your indexed calls</div>
            <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900"></div>
          </div>
        </button>
        
        {/* Badge for "new" feature (optional - can be removed after users are familiar) */}
        <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full animate-bounce">
          NEW
        </div>
      </div>

      {/* Q&A Chat Modal */}
      <QAChatModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default QAFloatingButton;

